function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendMessageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    fill: "currentColor",
    viewBox: "0 0 40 37.333333",
    "aria-label": "Create message",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 0,37.239394 39.928919,18.619697 0,0 V 14.481987 L 28.520656,18.619697 0,22.757407 Z",
    id: "path2",
    style: {
      strokeWidth: 1.98335
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendMessageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send-message-icon.5ef1e3b74114d0569da25e9a8eb22a40.svg";